import { useFlags } from 'launchdarkly-react-client-sdk'
import { IS_DEV } from '@/common/env'
import useDevOverrideStore from './devOverrides/devOverrideStore'

export type BaseFlagValue = boolean | string

// Raw LD values keyed by consumer flag name (see flagDefinitions.ts), with no dev overrides applied.
// Used by the dev panel so "no override" falls back to the real LD state instead of a static default.
export function useBaseFlagValues(): Record<string, BaseFlagValue> {
    const { downtimePage } = useFlags()

    return {
        showDownTimePage: downtimePage ?? false,
    }
}

export function useFeatureFlags() {
    const { downtimePage } = useFlags()
    const overrides = useDevOverrideStore((s) => s.overrides)

    return {
        showDownTimePage: (IS_DEV ? (overrides.showDownTimePage as boolean) : undefined) ?? downtimePage ?? false,
    }
}
